// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LWwh","textarea":"styles_textarea__1eR1n"};